<template>
  <div class="index-page pa-8">
    <SelectBusinessHeader />

    <!-- <v-card elevation="0" class="px-sm-8 px-md-10">
      <v-card-title class="justify-center title-text px-sm-10 pt-sm-10">
        โปรไฟล์ธุรกิจ
      </v-card-title>
      <v-card-text>
        <SelectBusinessHeader />
      </v-card-text>
    </v-card> -->
    <div>
      <ProfileHeader :business_data="business_profile[0]" />
    </div>
    <div class="pt-8">
      <BusinessDetails :business_data="business_profile[0]" />
    </div>
    <div
      v-if="
        theme !== 'UTCC_JOBFAIR_ADMIN' &&
        (!business_type_fairoo || business_type_fairoo == null)
      "
      class="pt-8 position-news"
    >
      <NewsProfile :newsData="newsData" />
    </div>
    <div
      v-if="
        theme !== 'UTCC_JOBFAIR_ADMIN' &&
        (!business_type_fairoo || business_type_fairoo == null)
      "
      class="pt-8"
    >
      <v-slide-y-transition
        mode="out-in"
        :duration="{ enter: 500, leave: 500 }"
        appear
      >
        <!-- <ProfileForm
          v-if="
            user.role == '4' &&
            (edit_mode == true || showProfileAddSuccess == false)
          "
          @clickedSetDefaultMode="clickedSetDefaultMode"
          @clickedCancleDefaultMode="clickedCancleDefaultMode"
          :edit_mode="edit_mode"
          :showProfileAddSuccess="showProfileAddSuccess"
        /> -->
        <!-- <ProfileDetail
          v-else
          :business_data="business_profile[0]"
          @clickedSetEditMode="clickedSetEditMode"
          :showProfileAddSuccess="showProfileAddSuccess"
        /> -->
        <CompanySetting
          :business_data="business_profile[0]"
          @clickedSetEditMode="clickedSetEditMode"
          :showProfileAddSuccess="showProfileAddSuccess"
        />
      </v-slide-y-transition>
      <!-- <div class="pt-8">
        <PayMentDetails />
      </div> -->
    </div>

    <DialogFreePackage
      v-model="dialogFreePackage"
      :package-name="packageName"
      :loading="isLoadingClaim"
      @close="handleCloseFreePackage"
      @confirm="confirmFreePackage"
    />

    <DialogClaimSuccess
      v-model="dialogClaimSuccess"
      @redirect="goToTalentSearch"
    />

    <DialogSuccess
      :dialogSuccess="dialogSuccess"
      @clickedCloseDialog="clickedCloseDialogSuccess"
    />
    <DialogJoinBusiness
      v-if="
        business_profile && business_profile.length > 0 && business_join == true
      "
      :data="business_profile"
      :dialogJoinBusiness="dialogJoinBusiness"
      @clickedCloseDialogJoinSuccess="clickedCloseDialogJoinSuccess"
    />
    <FaqDialog
      :show="dialogopen"
      v-if="refcode != 'moph' && referral_status_ready && referral_status === 0"
      @submitSuccess="handleSurveyOpen"
    ></FaqDialog>
    <!-- wlc phase 5.2 wait api -->
    <div style="z-index: 2500 !important">
      <dialog-survey
        :csat_survey="!!csat_survey"
        v-if="csat_survey === 1 && (referral_status != 0 || showSurvey)"
      />
    </div>
  </div>
</template>

<script>
import DialogFreePackage from "../../components/DialogFreePackage.vue";
import DialogClaimSuccess from "../../components/DialogClaimSuccess.vue";
import { mapGetters } from "vuex";
import SelectBusinessHeader from "../../components/SelectBusinessHeader.vue";
// import ProfileDetail from "../../components/BusinessProfile/Profile/ProfileDetail.vue";
// import ProfileForm from "../../components/BusinessProfile/Profile/ProfileForm.vue";
import DialogSuccess from "../../components/BusinessProfile/Profile/DialogSuccess.vue";
import CompanySetting from "../../components/BusinessProfile/Profile/CompanySetting.vue";
import ProfileHeader from "../../components/BusinessProfile/Profile/ProfileHeader.vue";
import NewsProfile from "../../components/BusinessProfile/Profile/NewsProfile.vue";
import BusinessDetails from "../../components/BusinessProfile/Profile/BusinessDetails.vue";
// import PayMentDetails from "@/components/BusinessProfile/Profile/PayMentDetails.vue";
import DialogJoinBusiness from "../../components/Registry/Business/DialogJoinBusiness.vue";
import DialogSurvey from "@/components/DialogSurvey.vue";
import FaqDialog from "../../components/FaqPage/FaqDialog.vue";
// import DialogSurvey from "@/components/DialogSurvey.vue";

export default {
  name: "BusinessProfilePage",
  components: {
    DialogFreePackage,
    DialogClaimSuccess,
    SelectBusinessHeader,
    // ProfileForm,
    CompanySetting,
    DialogSuccess,
    ProfileHeader,
    NewsProfile,
    BusinessDetails,
    DialogJoinBusiness,
    DialogSurvey,
    // PayMentDetails,
    FaqDialog,
  },
  data() {
    return {
      // role: JSON.parse(localStorage.getItem("user_data")) || null,
      edit_mode: false,
      dialogSuccess: false,
      dialogJoinBusiness: false,

      refcode: localStorage.getItem("refcode") || null,
      dialogopen: false,
      referral_status_ready: false,
      showSurvey: false,
      theme: process.env.VUE_APP_USE_THEME,
      referral_status: localStorage.getItem("referral_status") || "-",
      business_type_fairoo:
        localStorage.getItem("business_type_fairoo") || null,
      dialogFreePackage: false,
      dialogClaimSuccess: false,
      hasCheckedCredit: false,
      packageName: "",
      packageCode: "",
      packageKey: "",
      isLoadingClaim: false, // เพิ่ม loading state
      THEME: process.env.VUE_APP_USE_THEME,
    };
  },
  computed: {
    ...mapGetters({
      business_profile: "business_profile",
      position_role: "position_role",
      newsData: "newsData",
      user: "user",
      business_join: "businessJoin",
      csat_survey: "csat_survey",
      referral_status_store: "referral_status",
    }),
    showProfileAddSuccess() {
      let show = true;

      if (this.business_profile[0]) {
        if (
          !this.business_profile[0].business_type_name_th ||
          (this.business_profile[0].business_type_name_th == "อื่นๆ" &&
            this.business_profile[0].business_type_other == null) ||
          !this.business_profile[0].business_detail ||
          !this.business_profile[0].products_and_services ||
          !this.business_profile[0].business_logo
        ) {
          show = false;
        }
      }
      return show;
    },
    biz_id() {
      let biz_id = null;
      if (this.business_profile[0]) {
        biz_id = this.business_profile[0].business_id;
      } else {
        biz_id = null;
      }
      return biz_id;
    },
  },
  mounted() {
    setTimeout(() => {
      if (parseInt(localStorage.getItem("referral_status")) === 1) {
        this.dialogopen = false;
      }
    }, 100);
  },
  created() {
    this.$store.dispatch("getBusinessNews");
    if (this.business_join == true) {
      this.dialogJoinBusiness = true;
    }
    if (parseInt(localStorage.getItem("referral_status")) === 1) {
      this.dialogopen = false;
    }
  },
  watch: {
    biz_id(val, oldVal) {
      if (val != oldVal) {
        this.edit_mode = false;
      }
    },
    // ✅ 2. เริ่มต้น Check สิทธิ์ฟรี ที่นี่ก่อนเสมอ
    business_profile: {
      handler(newVal) {
        if (newVal.length > 0 && newVal[0].business_id) {
          if (this.THEME == "WLC" && this.refcode == "one_id") {
            this.checkCredit(newVal[0].business_id);
          }
        }
      },
      deep: true,
      immediate: true,
    },
    referral_status(newValue) {
      if (newValue === 1) {
        this.dialogopen = false;
      } else {
        this.dialogopen = true;
      }
    },
  },
  methods: {
    clickedSetDefaultMode() {
      this.edit_mode = false;
      this.$store.dispatch("getBusinessProfile");
      this.$vuetify.goTo(0);
      this.dialogSuccess = true;
    },
    clickedCancleDefaultMode() {
      if (this.showProfileAddSuccess == false) {
        this.$router.push("/home");
      } else {
        this.edit_mode = false;
        this.$store.dispatch("getBusinessProfile");
        this.$vuetify.goTo(0);
      }
    },
    clickedSetEditMode() {
      this.$vuetify.goTo(0);
      this.edit_mode = true;
    },
    clickedCloseDialogSuccess() {
      this.dialogSuccess = false;
    },
    clickedCloseDialogJoinSuccess() {
      this.dialogJoinBusiness = false;
    },
    handleSurveyOpen() {
      this.showSurvey = true;
    },

    // ✅ 3. ฟังก์ชันเช็คสิทธิ์ (ทำงานเป็นด่านแรก)
    async checkCredit(businessId) {
      if (this.hasCheckedCredit) return;

      try {
        // กำหนด Header ก่อนเรียก API (ย้ายขึ้นมา)
        this.axios.defaults.headers.common["Authorization"] =
          "Bearer " + localStorage.getItem("token");

        const { data } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_package_order/check_credit?business_id=${businessId}`
        );

        if (data.flat_credit === false || data.flat_credit === "false") {
          // >> กรณีได้รับสิทธิ์: เปิด Dialog รับสิทธิ์ (หยุดรอ User)
          if (data.data) {
            this.packageName = data.data.package_name || "แพ็กเกจทดลองใช้งาน";
            this.packageCode = data.data.package_code;
            this.packageKey = data.data.package_key;
          }
          // console.log(this.packageName);
          // console.log(this.packageCode);
          // console.log(this.packageKey);

          this.dialogFreePackage = true;
        } else {
          // >> กรณีไม่ได้สิทธิ์/เคยรับแล้ว: ไปเรียก Survey ต่อทันที
          this.fetchSurveyStatus(businessId);
        }
        this.hasCheckedCredit = true;
      } catch (error) {
        console.error("Error checking credit:", error);
        // Error ก็ให้ไปต่อที่ Survey
        this.fetchSurveyStatus(businessId);
      }
    },

    // ✅ 4. ฟังก์ชันเมื่อกดปิด Dialog รับสิทธิ์ (ยังไม่รับ)
    handleCloseFreePackage() {
      this.dialogFreePackage = false;
      // เมื่อปิดแล้ว ให้ไปเรียก Survey ต่อ
      if (this.business_profile[0]) {
        this.fetchSurveyStatus(this.business_profile[0].business_id);
      }
    },

    // ✅ 5. ฟังก์ชันเรียก Survey (ทำงานทีหลัง)
    async fetchSurveyStatus(businessId) {
      try {
        // ใช้ ID ที่ส่งมา หรือดึงจาก state
        const bizId =
          businessId ||
          (this.business_profile[0]
            ? this.business_profile[0].business_id
            : null);
        if (!bizId) return;

        const refcode = localStorage.getItem("refcode");
        let site = null;
        if (refcode == "moph") {
          site = "MOPH_ADMIN";
        } else {
          site = this.theme;
        }

        await this.$store.dispatch("fetchCsatSurvey", {
          biz_id: bizId,
          site: site,
        });
      } catch (error) {
        console.error("Error fetching CSAT Survey:", error);
      }
    },

    async confirmFreePackage() {
      this.isLoadingClaim = true;
      try {
        const businessId = this.business_profile[0].business_id;
        // const today = new Date();
        // const packageStartDate = today.toISOString().split("T")[0];

        const payload = {
          business_id: businessId,
          package_code: this.packageCode,
          package_key: this.packageKey,
          current_date: 1, // ถ้าเลือกวันเอง
          // package_start_date: packageStartDate,
        };
        // console.log(payload);

        // เพิ่ม config headers เป็น argument ตัวที่ 3
        await this.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_package_order/order_manual`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        this.dialogFreePackage = false;
        this.dialogClaimSuccess = true;
      } catch (error) {
        console.error("Error claiming package:", error);
      } finally {
        this.isLoadingClaim = false;
      }
    },

    goToTalentSearch() {
      this.dialogClaimSuccess = false;
      this.$router.push("/talentsearch");
    },
  },
};
</script>

<style scoped>
.index-page {
  font-family: Noto Sans Thai !important;
}
.title-text {
  font-size: 20px;
  font-weight: 700;
  color: #333333;
}
.position-news {
  position: relative;
  z-index: 1;
}
</style>
